import { render, staticRenderFns } from "./HighlightList.vue?vue&type=template&id=0fadfba3&scoped=true&"
import script from "./HighlightList.vue?vue&type=script&lang=js&"
export * from "./HighlightList.vue?vue&type=script&lang=js&"
import style0 from "./HighlightList.vue?vue&type=style&index=0&id=0fadfba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fadfba3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VChip,VCol,VImg,VRow})
